<script>
    export let src;
    export let alt;
</script>

<img src="{src}" alt="{alt}" />

<style>
    img{
        width: 100%;
    }
</style>